import React from 'react';
import ContactTwo from '../../components/Contact/ContactTwo';
import Breadcrumb from '../../components/Breadcrumb';

const ContactMain = () => {
  return (
    <main>
      <Breadcrumb pageTitle="Contact" />

      <ContactTwo />
   
    </main>
  );
};

export default ContactMain;
